/**
 * This page will handle all the redirections cases
 */
import { CircularProgress } from "@mui/material";
import { APP_SOURCE, REACT_NATIVE_APP_EVENTS, REDIRECT_PAGE_IDS } from "data/constants";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getBusinessDataObj,
  updateBusinessSlice,
} from "redux-store/slices/BusinessSlice";
import { updateCartSlice } from "redux-store/slices/CartSlice";
import { updateCashRegisterSlice } from "redux-store/slices/CashRegisterSlice";
import { updateCheckoutSlice } from "redux-store/slices/CheckoutSlice";
import { updateCustomerSlice } from "redux-store/slices/CustomerSlice";
import { updateDiscountSlice } from "redux-store/slices/DiscountSlice";
import { updateGlobalSlice } from "redux-store/slices/GlobalSlice";
import { updateItemStatusSlice } from "redux-store/slices/ItemStatusSlice";
import { updateItemSlice } from "redux-store/slices/ItemsSlice";
import { updateLocalPaymentInfoSlice } from "redux-store/slices/LocalPaymentInfo";
import { updateLocalServerSlice } from "redux-store/slices/LocalServerSlice";
import { updateLoginSlice } from "redux-store/slices/LoginSlice";
import { updateLoyaltySlice } from "redux-store/slices/Loyalty";
import { updateMyOrderSlice } from "redux-store/slices/MyOrderSlice";
import { updateOutletSlice } from "redux-store/slices/OutletStatusSlice";
import { updatePosSettingsSlice } from "redux-store/slices/PosSettingsSlice";
import { updatePrinterSlice } from "redux-store/slices/PrinterSlice";
import { updateRegisterSlice } from "redux-store/slices/RegisterSlice";
import { updateRequestHeaderSlice } from "redux-store/slices/RequestHeaderSlice";
import { updateSaleSlice } from "redux-store/slices/SaleSlice";
import { updateSaleSummarySlice } from "redux-store/slices/SaleSummarySlice";
import { updateSupportSlice } from "redux-store/slices/SupportSlice";
import { updateTableViewSlice } from "redux-store/slices/TableViewSlice";
import { updateCatalogSlice } from "redux-store/slices/catalogueSlice";
import { setLocalStorage } from "utils";
import { LOCALSTORAGE_KEYS } from "utils/constants";
import { isAndroid, sendDataToApp } from "utils/nativeHooks";
import {
  CHECKOUT_CONTAINER_ROUTE,
  CUSTOMER_INFO_ROUTE,
  DETAILS_VIEW_ROUTE,
  DISCOUNT_DEALS_ROUTE,
  ITEM_STATUS_ROUTE,
} from "utils/routeConstants";
import { POS_NAV_ID } from "utils/sideNavConstants";

const PAGE_ID = "page_id";
const RedirectPage = () => {
  const navigateTo = useNavigate();
  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();
  const pageId = searchParams.get(PAGE_ID) || "";
  const SKIP_PAGE_IDS = [
    REDIRECT_PAGE_IDS.ITEM_STATUS
  ];

  useEffect(() => {
    if (isAndroid()) {
      const urlParams = new URLSearchParams(window.location.search);
      const atoken: any = urlParams.get("atoken") || "",
        appSource = urlParams.get(APP_SOURCE) || "";
      console.log(urlParams, "===========urlParams===========", atoken);
      if (atoken) {
        const deviceIdentifier: any = urlParams.get("deviceIdentifier") || "";
        localStorage.setItem(LOCALSTORAGE_KEYS.aToken, atoken);
        localStorage.setItem(LOCALSTORAGE_KEYS.deviceIdentifier, deviceIdentifier);
        localStorage.setItem(APP_SOURCE, appSource);
        dispatch(getBusinessDataObj({}));
      }
    }
    window.addEventListener("message", receiveDataFromNativeApp);
    document.addEventListener("message", receiveDataFromNativeApp);
    return () => {
      document.removeEventListener("message", receiveDataFromNativeApp);
      window.removeEventListener("message", receiveDataFromNativeApp);
    };
  }, []);

  useEffect(() => {
    console.log("--INSIDE---redirect_page");
    // let routeUrl = getPageRoute(searchParams.get(PAGE_ID) || "");
    if (checkSkipReducerData()) {
      //directly navigate to page
      navigateTo(getPageRoute(pageId));
      return;
    }
    // navigateTo(routeUrl);
    setTimeout(
      () =>
        sendDataToApp({
          eventName: REACT_NATIVE_APP_EVENTS.getReducerState,
        }),
      100
    );

    // dispatch required actions
  }, []);

  /**
   * 
   * @returns true if this page is only of SKIP_PAGE_IDS array
   */
  function checkSkipReducerData() {
    let otherProps: any = JSON.parse(
      localStorage.getItem(LOCALSTORAGE_KEYS.webviewProps) || "{}"
    );
    return SKIP_PAGE_IDS.includes(pageId) && otherProps?.id !== POS_NAV_ID
  }

  function getPageRoute(pageId: string) {
    switch (pageId) {
      case REDIRECT_PAGE_IDS.DISCOUNT_DEALS:
        return DISCOUNT_DEALS_ROUTE;
      case REDIRECT_PAGE_IDS.CHECKOUT_CONTAINER:
        return CHECKOUT_CONTAINER_ROUTE;
      case REDIRECT_PAGE_IDS.CUSTOMER_INFO:
        return CUSTOMER_INFO_ROUTE;
      case REDIRECT_PAGE_IDS.ITEM_STATUS:
        return ITEM_STATUS_ROUTE;
      case REDIRECT_PAGE_IDS.DETAILS_VIEW:
        return DETAILS_VIEW_ROUTE;
      default:
        return DISCOUNT_DEALS_ROUTE;
    }
  }

  function receiveDataFromNativeApp(event: any) {
    let response;
    if (typeof event?.data === "string") {
      try {
        response = JSON.parse(event.data);
      } catch (err) {
        console.error("Not valid JSON:", event.data);
        return;
      }
    }
    console.log(
      "----INSIDE----EVENT RECEIVED-------eventName=",
      response?.eventName
    );
    // console.log("--------EVENT RECEIVED-------response", response);
    if (response?.eventName === "reactNative.getReducerState") {
      console.log("----INSIDE----EVENT RECEIVED-------data=", response?.data);
      console.log("----INSIDE----EVENT RECEIVED-------customProps=", response?.customProps);
      if (response?.customProps && Object.keys(response.customProps)?.length) {
        setLocalStorage("webviewProps", JSON.stringify(response?.customProps));
      }
      const reducerData: any = response?.data || {};
      dispatch(updateCatalogSlice(reducerData.catalogStore));
      dispatch(updateItemSlice(reducerData.itemsStore));
      dispatch(updatePosSettingsSlice(reducerData.posSettingsStore));
      dispatch(updateTableViewSlice(reducerData.tableViewStore));
      dispatch(updateGlobalSlice(reducerData.globalStore));
      dispatch(updateCustomerSlice(reducerData.customerStore));
      dispatch(updateSaleSlice(reducerData.saleDataStore));
      dispatch(updateBusinessSlice(reducerData.businessStore));
      dispatch(updateDiscountSlice(reducerData.discountStore));
      dispatch(updateRegisterSlice(reducerData.registerStore));
      dispatch(updateLoginSlice(reducerData.loginStore));
      dispatch(updateCheckoutSlice(reducerData.checkoutModalStore));
      dispatch(updateCartSlice(reducerData.cartStore));
      dispatch(updateLocalPaymentInfoSlice(reducerData.localPaymentInfoStore));
      dispatch(updateLoyaltySlice(reducerData.LoyaltyStore));
      dispatch(updateItemStatusSlice(reducerData.ItemsStatusStore));
      dispatch(updateOutletSlice(reducerData.OutletStatusStore));
      dispatch(updatePrinterSlice(reducerData.printerStore));
      dispatch(updateRequestHeaderSlice(reducerData.requestHeaderStore));
      dispatch(updateSupportSlice(reducerData.supportStore));
      dispatch(updateSaleSummarySlice(reducerData.saleSummary));
      dispatch(updateCashRegisterSlice(reducerData.cashRegisterStore));
      dispatch(updateLocalServerSlice(reducerData.localServer));
      dispatch(updateMyOrderSlice(reducerData.myOrderStore));
      console.log("-----PAGE_id", searchParams?.get(PAGE_ID));
      setTimeout(() => {
        if (searchParams.get(PAGE_ID)) {
          let routeUrl = getPageRoute(searchParams.get(PAGE_ID) || "");
          navigateTo(routeUrl);
        }
      }, 100);
    }
  }

  return (
    <section className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#fafafa] text-22 font-medium">
      <CircularProgress sx={{ width: "25px", height: "25px" }} />
    </section>
  );
};

export default RedirectPage;
